// SHARED-007: Economy formulas

/** Upgrade cost = currentLevel * 50 ₣ — GDD §4.8.2 */
export function calcUpgradeCost(currentLevel: number): number {
  return currentLevel * 50;
}

/** Resell price = floor(originalPrice * 0.5) — GDD §4.2.3 */
export function calcResellPrice(originalPrice: number): number {
  return Math.floor(originalPrice * 0.5);
}

/** Inflation: every 10 completed projects → price +10% — GDD §4.7.3 */
export function calcInflation(completedProjects: number): number {
  return 1 + Math.floor(completedProjects / 10) * 0.1;
}

/** Apply inflation to a base price */
export function applyInflation(basePrice: number, completedProjects: number): number {
  return Math.round(basePrice * calcInflation(completedProjects));
}
